import type { Theme } from '../../types/theme';

export const linearTheme: Theme = {
  id: 'linear',
  name: 'Linear',
  description: 'Ultra-minimal dark interface with precision engineering aesthetics. Deep black with lavender accents.',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/linear-app/DESIGN.md',
  visualKeywords: ['dark', 'minimal', 'precision', 'engineer', 'lavender accent', 'dense UI'],
  colors: {
    background: '#010102',
    surface: '#0f1011',
    surfaceElevated: '#141516',
    surfaceDark: '#010102',
    textPrimary: '#f7f8f8',
    textSecondary: '#d0d6e0',
    textMuted: '#8a8f98',
    border: '#23252a',
    borderSubtle: '#34343a',
    primary: '#5e6ad2',
    primaryHover: '#828fff',
    primaryActive: '#5e69d1',
    accent: '#5e6ad2',
    onPrimary: '#ffffff',
    success: '#27a644',
    warning: '#d4a017',
    error: '#c64545',
  },
  typography: {
    headingFont: '"SF Pro Display", -apple-system, system-ui, sans-serif',
    bodyFont: '"SF Pro Text", -apple-system, system-ui, sans-serif',
    monoFont: '"JetBrains Mono", Menlo, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-1.8px',
    letterSpacingBody: '-0.05px',
  },
  radius: {
    button: '8px',
    card: '12px',
    panel: '16px',
    badge: '9999px',
    input: '8px',
  },
  shadow: {
    card: 'none',
    elevated: 'none',
    button: 'none',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '96px',
    cardPadding: '24px',
    navHeight: '56px',
  },
  mood: {
    density: 'high',
    tone: 'precise, technical, software-craft',
    productFit: ['Developer tools', 'Project management', 'Code editors', 'API platforms'],
    bestFor: ['Developer-centric products', 'Engineering teams', 'Technical documentation'],
    notGoodFor: ['Consumer apps', 'Creative tools', 'E-commerce', 'Social platforms'],
  },
};
